import { createFileRoute } from "@tanstack/react-router";
import CategoriesManager from "@/pages/admin/CategoriesManager";

export const Route = createFileRoute("/admin/categories")({
  component: CategoriesManager,
});
